import { useDocumentsManagement, useDocumentsModals } from 'modules/documents/common/contexts'
import { UploadLoading } from 'modules/documents/upload-loading'

export const UploadLoadingManagement = () => {
  const { openDocumentsModal } = useDocumentsModals()
  const { uploadProgress, isUploading } = useDocumentsManagement()

  if (!isUploading) return null

  return (
    <button type="button" onClick={openDocumentsModal}>
      <UploadLoading currentFile={uploadProgress.current} totalFiles={uploadProgress.total} variant="solid" />
    </button>
  )
}
